(function () {
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Nav drawer + More dropdown */
  var drawer = document.querySelector('[data-nav-drawer]');
  var backdrop = document.querySelector('[data-nav-backdrop]');
  var openBtn = document.querySelector('[data-nav-open]');
  var closeBtn = document.querySelector('[data-nav-close]');
  var moreRoot = document.querySelector('[data-nav-more]');
  var moreBtn = document.querySelector('[data-nav-more-btn]');
  var morePanel = document.querySelector('[data-nav-more-panel]');
  var lastFocus = null;

  var getFocusable = function () {
    if (!drawer) return [];
    return Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      return !el.hasAttribute('disabled') && el.offsetParent !== null;
    });
  };

  var onDrawerKeydown = function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Tab') {
      var items = getFocusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  var setDrawer = function (open) {
    if (!drawer || !backdrop) return;
    if (open) {
      lastFocus = document.activeElement;
      drawer.removeAttribute('inert');
    }
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (!open) drawer.setAttribute('inert', '');
    backdrop.hidden = !open;
    requestAnimationFrame(function () {
      backdrop.classList.toggle('is-open', open);
    });
    document.body.classList.toggle('nav-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var focusTarget = closeBtn || getFocusable()[0];
      if (focusTarget) focusTarget.focus();
      document.addEventListener('keydown', onDrawerKeydown);
    } else {
      document.removeEventListener('keydown', onDrawerKeydown);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
  };

  if (drawer && !drawer.classList.contains('is-open')) {
    drawer.setAttribute('inert', '');
  }

  var setMore = function (open) {
    if (!moreBtn || !morePanel) return;
    moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    morePanel.hidden = !open;
  };

  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });

  if (moreBtn) {
    moreBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      setMore(morePanel.hidden);
    });
  }
  document.addEventListener('click', function (e) {
    if (moreRoot && !moreRoot.contains(e.target)) setMore(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setDrawer(false);
      setMore(false);
    }
  });

  /* Reveal-on-scroll — fast, skip on reduce-motion / Save-Data, no blank first paint */
  var revealNodes = document.querySelectorAll('.reveal');
  var skipReveal =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    (navigator.connection && navigator.connection.saveData);

  if (skipReveal || !('IntersectionObserver' in window)) {
    revealNodes.forEach(function (el) {
      el.classList.add('is-in');
      el.style.transitionDelay = '0s';
    });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px 12% 0px', threshold: 0.01 }
    );
    revealNodes.forEach(function (el) {
      // Cap staggered delays so mid-range Androids don't wait on a cascade
      var delay = parseFloat(el.style.transitionDelay || '0') || 0;
      if (delay > 0.12) el.style.transitionDelay = '0.12s';
      io.observe(el);
    });
  }

  /* Sticky buy bar — shows when main CTA leaves the viewport */
  var cta = document.querySelector('[data-product-cta]');
  var sticky = document.querySelector('[data-sticky-buy]');
  if (cta && sticky && 'IntersectionObserver' in window) {
    var stickyIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (sticky.hasAttribute('data-sticky-force-hidden') || entry.isIntersecting) {
            sticky.setAttribute('hidden', '');
            document.body.classList.remove('has-sticky-buy');
          } else {
            sticky.removeAttribute('hidden');
            document.body.classList.add('has-sticky-buy');
          }
        });
      },
      { threshold: 0, rootMargin: '-8px 0px 0px 0px' }
    );
    stickyIo.observe(cta);
  }

  /* Homepage hero slider */
  var hero = document.querySelector('[data-hero-slider]');
  if (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = 6500;

    var loadSlideMedia = function (slide) {
      if (!slide) return;
      var img = slide.querySelector('img[data-src]');
      if (!img) return;
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    };

    var goTo = function (next) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      loadSlideMedia(slides[index]);
      /* Prefetch the following slide so autoplay feels instant */
      loadSlideMedia(slides[(index + 1) % slides.length]);
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.setAttribute('aria-current', 'false');
      });
    };

    var stop = function () {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    var start = function () {
      stop();
      if (reduceMotion || slides.length < 2) return;
      timer = setInterval(function () {
        goTo(index + 1);
      }, interval);
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
        start();
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget)) start();
    });

    /* Touch swipe for mobile (arrows are hidden below 700px) */
    var touchX = null;
    hero.addEventListener('touchstart', function (e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      touchX = e.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (touchX === null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 48) {
        goTo(index + (dx < 0 ? 1 : -1));
      }
      start();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    /* Warm the next slide after first paint so autoplay isn't blank */
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { loadSlideMedia(slides[1]); }, { timeout: 2500 });
    } else {
      setTimeout(function () { loadSlideMedia(slides[1]); }, 1800);
    }

    start();
  }

  /* Category browse carousel */
  document.querySelectorAll('[data-cat-browse]').forEach(function (root) {
    var track = root.querySelector('[data-cat-track]');
    var prev = root.querySelector('[data-cat-prev]');
    var next = root.querySelector('[data-cat-next]');
    if (!track) return;
    var scrollBy = function (dir) {
      track.scrollBy({ left: dir * Math.max(240, track.clientWidth * 0.7), behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  });

  /* PWA Add to Home Screen — soft prompt after a return visit */
  (function () {
    var banner = document.querySelector('[data-a2hs-banner]');
    if (!banner) return;

    var storageKey = 'jaanci_a2hs_dismissed';
    var visitKey = 'jaanci_a2hs_visits';
    var installBtn = banner.querySelector('[data-a2hs-install]');
    var dismissBtn = banner.querySelector('[data-a2hs-dismiss]');
    var deferredPrompt = null;
    var standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    var isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent || '');

    if (standalone) return;
    try {
      if (localStorage.getItem(storageKey) === '1') return;
    } catch (e) {}

    var visits = 0;
    try {
      visits = parseInt(localStorage.getItem(visitKey) || '0', 10) || 0;
      visits += 1;
      localStorage.setItem(visitKey, String(visits));
    } catch (e) {}

    var show = function () {
      if (!banner.hidden) return;
      banner.hidden = false;
      document.body.classList.add('has-a2hs');
    };
    var hide = function () {
      banner.hidden = true;
      document.body.classList.remove('has-a2hs');
      try { localStorage.setItem(storageKey, '1'); } catch (e) {}
    };

    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      deferredPrompt = e;
      if (visits >= 2) show();
    });

    if (visits >= 2) {
      window.setTimeout(function () {
        if (deferredPrompt) {
          show();
        } else if (isIos) {
          if (installBtn) installBtn.textContent = 'How';
          show();
        }
      }, 1200);
    }

    if (dismissBtn) dismissBtn.addEventListener('click', hide);
    if (installBtn) {
      installBtn.addEventListener('click', function () {
        if (deferredPrompt) {
          deferredPrompt.prompt();
          Promise.resolve(deferredPrompt.userChoice).finally(function () {
            deferredPrompt = null;
            hide();
          });
          return;
        }
        if (isIos) {
          installBtn.textContent = 'Share → Add';
          return;
        }
        hide();
      });
    }
  })();
})();

